import React from 'react';
import { TextList, SimpleChoiceList, CardChoiceList, ImageList, PdfList, AdaptiveCardList, MarkdownList, CarouselList } from './';
import { Content } from '../types';

type Props = {
	scrollRef:any;
	contentType: string;
	contents: Content[];
	hasMore:boolean;
	refetchContent: () => void;
	loadMore: () => void;
};

export function SelectedContent(props: Props) {
	const contentMap: Record<string, React.ElementType> = {
		'text': TextList,
		'simpleChoice': SimpleChoiceList,
		'cardChoice': CardChoiceList,
		'pdf': PdfList,
		'image': ImageList,
		'autoComplete': CardChoiceList,
		'cardCarousel': CarouselList,
		'adaptiveCard': AdaptiveCardList,
		'markdown': MarkdownList,
	}
	const Component = contentMap[props.contentType]
	if(!Component) {
		return null
	}
	return <Component {...props} isAutocomplete={props.contentType === 'autoComplete'} />
}
